import useShoppingCart from '@dustin-web/product-components/src/hooks/dataloader/use-shopping-cart'
import { useGraphqlMutation } from '@dustin-web/microsite-data/src/hooks'
import { RequiredEndUserInformation } from './cart-required-end-user-information'
import { UpsertRequiredEndUserInformation } from '@cartsite-app/src/graphql/upsert-required-end-user-information.graphql'
import {
  UpsertRequiredEndUserInformationMutation,
  UpsertRequiredEndUserInformationMutationVariables,
} from '@cartsite-app/src/graphql/generated/graphql-types'
import { CartItemFragment } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

export default function EndUserInformation({ item }: { item: CartItemFragment }) {
  const { product } = item
  const { refetchCart } = useShoppingCart({
    withRequiredEndUserInformation: true,
  })
  const [upsertEndUserInformation] = useGraphqlMutation<
    UpsertRequiredEndUserInformationMutation,
    UpsertRequiredEndUserInformationMutationVariables
  >(UpsertRequiredEndUserInformation)

  if (!product || !product.requiredEndUserInformation) return null

  return (
    <div className="u-flex-basis-100">
      {product.requiredEndUserInformation?.map(productEndUserInformation => (
        <RequiredEndUserInformation
          key={productEndUserInformation.label}
          label={productEndUserInformation.label || ''}
          value={
            item.endUserInformation?.find(
              cartItemEndUserInformation =>
                cartItemEndUserInformation?.lineNumber === productEndUserInformation.lineNumber
            )?.value || null
          }
          onSaveEndUserInformation={async (value: string) => {
            await upsertEndUserInformation({
              variables: {
                cartItemId: item.id,
                label: productEndUserInformation.label || '',
                lineNumber: productEndUserInformation.lineNumber,
                value,
              },
            })
            refetchCart()
          }}
        />
      ))}
    </div>
  )
}
